import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { ProfileData } from '../../../../models/profile/profile.model';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ActionHelper } from '../../../../helper/action.helper';
import { LOCALE_KEY } from '../../../../services/user-service/user-token.service';
import { UserProfileShareService } from "../../../../services/shared-service/user-profile-share.service";
import { Subscription } from "rxjs";
import { environment } from "../../../../environments/environment";
import { AdminMandant } from '../../../../models/cloud/cloud.model';

@Component({
  selector: 'fi-header-actions',
  templateUrl: './header-actions.component.html',
  styleUrls: ['./header-actions.component.scss'],
  standalone: false,
})
export class HeaderActionsComponent implements OnInit, OnDestroy {
  @Input() isMobile = false;
  @Input() isLaptop = false;
  @Input() profileData: ProfileData;
  @Input() adminMandant?: AdminMandant;

  activeItem: 'file' | 'user' | 'burger' | '' = '';
  enableReporting: boolean;
  private $userSubscription: Subscription;
  apiReportUrl = environment.apiReportUrl;

  constructor(
    private dialog: MatDialog,
    private readonly sharedProfileService: UserProfileShareService,
    private router: Router) {
  }

  ngOnInit(): void {
    this.onResize();
    this.$userSubscription = this.sharedProfileService.getProfile().subscribe(data => {
      this.enableReporting = data.User.EnableReporting;
    })
  }

  ngOnDestroy(): void {
    this.$userSubscription?.unsubscribe();
  }

  get language(): string {
    return sessionStorage.getItem(LOCALE_KEY);
  }

  get feedbackUrl(): string {
    if (this.language === 'fr') {
      return 'https://www.finstral.com/fr/information/finstral-contacts/347-0.html';
    } else if (this.language === 'es') {
      return 'https://www.finstral.com/es/information/finstral-contacts/347-0.html';
    } else if (this.language === 'de') {
      return 'https://www.finstral.com/de/information/finstral-contacts/347-0.html';
    } else if (this.language === 'it') {
      return 'https://www.finstral.com/it/informazioni/finstral-contacts/347-0.html';
    } else if (this.language === 'nl') {
      return 'https://www.finstral.com/nl/information/finstral-contacts/347-0.html';
    } else if (this.language === 'nl-BE') {
      return 'https://www.finstral.com/fl/information/finstral-contacts/347-0.html';
    } else {
      return 'https://forms.office.com/r/TBX8HRudQi';
    }
  }

  get feedbackContentText() : string {
    if (this.language === 'fr') {
      return 'Assistance';
    } else if (this.language === 'de' || this.language === 'nl' || this.language === 'nl-BE' || this.language === 'es') {
      return 'Support';
    } else if (this.language === 'it') {
      return 'Supporto';
    } else {
      return 'Feedback';
    }
  }

  setActiveItem(item: 'file' | 'user' | 'burger' | ''): void {
    this.activeItem = item;

    if (item === 'file') {
      ActionHelper.openNewRequestDialog(this.dialog, this.router);
    }
  }

  @HostListener('window:resize')
  onResize(): void {
    this.isLaptop = window.innerWidth <= 1024;
    this.isMobile = window.innerWidth <= 600;
  }


}
